// In-app notification feed (the bell).
import { api } from './client.js';

export const fetchNotifications = () => api.get('/me/notifications').then((r) => r.data);
export const markNotificationsRead = (ids) =>
  api.post('/me/notifications/read', ids ? { ids } : {}).then((r) => r.data);
